import React from 'react'
import classNames from 'classnames'
import { Type } from '@/components/common'
import Image from '@/components/contentful/Image'
import useCampaignAssets from '@/services/hooks/useCampaignAssets'

export interface Props {
  title: string
  subtitle: string
  description?: string | JSX.Element
  label?: string
  rightContent?: JSX.Element
  campaignSlug: string
  className?: string
}

const UserCampaignCard: React.FC<Props> = ({
  title,
  subtitle,
  description,
  label,
  rightContent,
  campaignSlug,
  className,
}) => {
  const { campaignAssets } = useCampaignAssets(campaignSlug)

  return (
    <div className={classNames('flex gap-4', className)}>
      {campaignAssets?.squareImage ? (
        <Image
          image={campaignAssets.squareImage}
          width={56}
          quality={100}
          lazy
          containerClassName="flex rounded overflow-hidden shrink-0"
        />
      ) : (
        <div className="h-[56px] w-[56px] shrink-0 rounded bg-core-gray-100" />
      )}

      <div className="flex flex-1 flex-col overflow-hidden">
        {label && (
          <Type
            as="label"
            variant="caption-sm"
            className="flex uppercase text-core-gray-700"
          >
            {label}
          </Type>
        )}

        <Type
          as="h3"
          variant="title-sm"
          className="mb-1 truncate text-ellipsis font-semibold"
        >
          {title}
        </Type>

        <Type as="div" variant="caption-lg" className="text-core-gray-700">
          {subtitle}
        </Type>

        {description && (
          <Type
            as="div"
            variant="caption-lg"
            className="mt-1 flex items-center text-core-gray-700"
          >
            {description}
          </Type>
        )}
      </div>

      {rightContent && (
        <div className="shrink-0 text-right">{rightContent}</div>
      )}
    </div>
  )
}

export default UserCampaignCard
